module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid9.f49cea6d.png";